export const DATA_TOKEN_SETTINGS = 'hsdatatokens';
export const OWNER_CATEGORY = 'owner';
export const SITE_SETTINGS_CATEGORY = 'site_settings';
export const HUBL_PATH = /{{-?\s*([a-zA-Z0-9_()\-[\]]+(?:[.][a-zA-Z0-9_()\-[\]]+)*)\s*-?}}/g;
export const HUBL_PERSONALIZATION_PATTERN = /{{-?\s*personalization_token\(\s*["']([a-zA-Z0-9_()\-[\]]+(?:[.][a-zA-Z0-9_()\-[\]]+)*)["']\s*,\s*["'](.*?)["']{1}\s*\)\s*-?}}/g;
export const ALL_TOKEN_PATTERN = /{{\s*(company|contact|deal|line_item|owner|quote|site_settings|ticket)\.(\w+)(?:\.(\w+))?\s*}}/g;
export const PROPERTY_ONLY_TOKEN_PATTERN = /{{\s*(subscription_name)?\s*}}/g;
export const TOKEN_PATTERN_WITH_DEFAULT = /{{\s*personalization_token\(\s*["']{1}([^\\.\s]+)\.(\w+)\.?(\w+)?["']{1}\s*,\s*["']{1}(.*?)["']{1}\s*\)\s*}}/g;
export const FILTER_PATTERN_FRAGMENT = '(?:\\|(.*?))?';
export const hsDataTokenConfig = {
  HIDE_SITE_SETTINGS_CATEGORY: 'hideSiteSettingsCategory',
  INCLUDE_SUBSCRIPTION_TYPE_CATEGORY: 'includeSubscriptionTypeCategory',
  INCLUDE_INTERNAL_CONTACT_RECORD: 'includeInternalContactRecord',
  INCLUDE_USER_OBJECT_PROPERTIES: 'includeUserObjectProperties',
  ALLOW_EMPTY_FALLBACKS: 'allowEmptyFallbacks',
  IS_EMAIL: 'isEmail',
  HIDE_FALLBACKS: 'hideFallbacks',
  SUPPORTED_CRM_OBJECT_FQNS: 'supportedCrmObjectFQNs',
  SUPPORTED_FIELD_TYPES: 'supportedFieldTypes',
  CUSTOM_OBJECT_PREFIXES: 'customObjectPrefixes',
  USE_FLEXIBLE_ASSOCIATIONS: 'useFlexibleAssociations',
  PROPERTY_FILTERS_CALLBACK: 'propertyFiltersCallback',
  USE_AS_UPGRADE_POINT: 'useAsUpgradePoint',
  TOKEN_PATHS_CONTENT_CONTEXT: 'dataTokenContentContext',
  TOKEN_PATHS_CONTEXT: 'dataTokenContext',
  UNSUPPORTED_TOKENS: 'unsupportedTokens',
  UNSUPPORTED_DATA_TOKEN_PATHS: 'unsupportedDataTokenPaths',
  UNSUPPORTED_REFERENCED_TYPES: 'unsupportedReferencedTypes',
  RENDER_DATA_TOKEN_POPOVER: 'renderDataTokenPopover',
  USE_DEFAULT_LABEL_FOR_CRM_OBJECT_TYPES: 'useDefaultLabelForCrmObjectTypes',
  MAX_TOKEN_WIDTH: 'maxTokenWidth',
  DATA_TOKEN_POPOVER_PLACEMENT: 'dataTokenPopoverPlacement',
  DELIVER_CUSTOM_EVENT_TYPES: 'deliverCustomEventTypes'
};